export default "__VITE_ASSET__DzzEgYob__"